// extracted by mini-css-extract-plugin
module.exports = {"callOut":"_7U7Y5C6b","infoIcon":"_1qtc3v2T"};